import React from 'react';
import RadioGroupBase from "oc-ui/react/RadioGroup.jsx";

export default class RadioGroup extends RadioGroupBase {
    classNameGroup() {
        return "f-10 input-wrapper " + (this.props.hidden?"disappear":"appear");
    }
}

